<div class="input-icon-start">
    <input type="text" class="form-control" [placeholder]="textinput || 'ค้นหา'" (change)="updateItems(filter)" #filter>
    <span class="material-symbols-outlined">
        search
    </span>
</div>